import { useEffect, useState } from "react";

export default function NetBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (online) return null;
  return (
    <div data-testid="offline-banner" style={{
      background: "#7c2d12", color: "#fed7aa", border: "1px solid #ea580c",
      borderRadius: 8, padding: "8px 14px", marginBottom: 12, fontSize: 13.5, fontWeight: 600,
    }}>
      ⚠️ Connessione internet assente — ti mostro gli ultimi dati salvati. Le modifiche riprenderanno quando torna la rete.
    </div>
  );
}
